import React, { useRef, useState } from "react";
import "./SingleSearchPage.css";
import axios from "axios";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import { Flex, Select, Spin } from "antd";
import { axiosPost, myInitHeader } from "../../services/API/ApiClient";
import { getSessionData } from "../../services/auth/AuthAPI";

function SingleSearchPage(props: any) {
  const [imageLoading, setImageLoading] = useState(false);
  const selectRef = useRef(null) as any;
  let hostname = "https://api.search-optimization-poc.wl-dev-logostore.com";
  let apiKey = "776446faa0df4f74943b009bc9af4b11";
  let pathname = "/collections/brands_mirrored_structure/documents/search";
  let queryBy = "Name,StockSymbols.ISIN,StockSymbols.Symbol,Tags";
  let perPage = "10";
  let sort_by = "_text_match:desc";
  let stopwords = "stopword_set1";
  let prioritize_token_position = "true";

  const [query, setQuery] = useState("");
  const [searchResults, setSearchResults] = useState({});
  const [searchTexts, setSearchTexts] = useState([]) as any;
  const [logos, setLogos] = useState([]) as any;
  const [items, setItems] = useState([]);

  const handleInputChange = async (value: any) => {
    setQuery(value);
    if (value === "") {
      setItems([]);
      setSearchResults({});
      return;
    }

    try {
      const myNewInit = myInitHeader(await getSessionData());
      let config = {
        headers: {
          "X-TYPESENSE-API-KEY": apiKey,
          ...myNewInit.headers,
        },
      };
      setItems([]);
      let url = `${hostname}${pathname}?q=${value}&query_by=${queryBy}&per_page=${perPage}&sort_by=${sort_by}&prefix=true&prioritize_token_position=true`;
      // &stopwords=${stopwords}`;
      const response = await axios.get(url, config);
      // console.log(value)
      // console.log(response.data);
      // setSearchResults({ ...response.data });
      setItems(response.data.hits);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const handleSearch = async () => {
    selectRef.current.blur();
    try {
      setImageLoading(true);
      let url = "https://api.wl-logostore.com/search";
      let data = {
        selectedItems: searchTexts,
        page: 1,
        pageSize: 30,
        format: "any",
        opacity: "any",
        colour: "standard",
        isLatest: false,
        isBest: true,
        isAsc: true,
        sortColumn: "searchOrder",
        type: "logo",
        isAlias: false,
        status: "",
        theme: "any",
      };
      const response = await axiosPost(url, data);
      const logos = [] as any;
      await response.data.data.tiles.map((item: any) => item.logos.map((logo: any) => logos.push({ imageUrl: logo.imageUrl })));
      setLogos(logos);
      setImageLoading(false);
    } catch (error) {
      setImageLoading(false);
      console.error("Error fetching data:", error);
    }
  };
  const SuffixIcon = () => {
    return <SearchOutlined onClick={() => handleSearch()} />;
  };

  return (
    <div className="d-flex flex-column h-100 align-items-center">
      <div className="d-flex content-container">
        <h3 className="text-center">Single Search</h3>
        <div className="search-container d-flex justify-content-center gap-3">
          <Select
            ref={selectRef}
            placeholder="input search text"
            size="large"
            showSearch
            mode="multiple"
            onChange={(value) =>
              setSearchTexts(
                value.map((item: any) => {
                  return { Key: "Name", Value: item };
                })
              )
            }
            value={searchTexts.map((item: any) => item.Value)}
            defaultActiveFirstOption={false}
            onSearch={(value) => handleInputChange(value)}
            // suffixIcon={<SuffixIcon />}
            suffixIcon={
              <SearchOutlined
                style={{ fontSize: 17 }}
                onClick={() => handleSearch()}
              />
            }
            filterOption={false}
            //   notFoundContent={null}
            tagRender={(props) => {
              const { label, value, closable, onClose } = props;
              return (
                <div className="tag">
                  <span>{value}</span>
                  <CloseOutlined onClick={() => onClose()} />
                </div>
              );
            }}
            optionRender={(item: any) => {
              console.log(item);
              return (
                <div className="d-flex w-100 justify-content-between">
                  <span>{item.label.name}</span>

                  <div className="d-flex gap-3">
                    {item.label.matches.map((match: any) => {
                      if (match === "Tags") {
                        return <span className="match-tag">Tag</span>;
                      }

                      return <span className="match-tag">{match}</span>;
                    })}
                  </div>
                </div>
              );
            }}
            options={items.map((item: any) => {
              return {
                value: item.document.Name,
                label: {
                  name: item.document.Name,
                  matches: item.highlights.map((highLight: any) => highLight.field),
                },
              };
            })}
            style={{ width: "100%" }}
          />
          <div
            // className="button"
            className="link d-flex justify-content-center align-items-center"
            onClick={() => {
              setItems([]);
              setSearchTexts([]);
              setLogos([]);
            }}>
            Clear
          </div>
        </div>
        <br />
        <Spin spinning={imageLoading}>
          <Flex
            wrap
            justify="center"
            gap="middle">
            {logos.map((logo: any, index: number) => (
              <div
                className="d-flex p-2 justify-content-center align-items-center"
                style={{
                  background: "repeating-conic-gradient(rgb(221, 221, 221) 0%, rgb(221, 221, 221) 25%, transparent 0%, transparent 50%) 50% center / 4.5% 4.5%",
                  height: 150,
                  width: 150,
                }}>
                <img
                  src={logo.imageUrl}
                  key={index}
                  width={100}
                  alt="logo"
                  className="logo-image"
                />
              </div>
            ))}
          </Flex>
        </Spin>
        {/* <div className="search-result-container">
          
        </div> */}
      </div>
    </div>
  );
}

export default SingleSearchPage;
